import { AnimationLoadingScreenWithProgressBar } from '../../../components/loading/loadingScreen';
import { VerifyEmailPageJSX } from './verifyEmail.components';
import { useUserDataFetcher, useVerificationLogic } from './verifyEmail.hooks';

/**
 * Renders a component for email verification.
 *
 * @returns {JSX.Element|string} - The rendered component or a string indicating unauthorized access.
 * @throws {Error} - If an error occurs during the verification process.
 */
export const VerifyEmailPage = () => {
  const { email, maskedEmail, phoneNumber, isInitialDataFetched } = useUserDataFetcher();
  const {
    code,
    setCode,
    incorrect,
    isLoading,
    responseReturned,
    handleVerify,
    handleSendVerify,
    sendNewCodeActivated
  } = useVerificationLogic( email, phoneNumber, isInitialDataFetched );

  // If no email and initial data is fetched, show unauthorized
  if ( isInitialDataFetched && !email ) {
    return 'Unauthorized.';
  }

  // Show loading screen only when actually loading
  if ( isLoading ) {
    return (
      <AnimationLoadingScreenWithProgressBar
        title="Loading..."
        secondsToLoad={ 30 }
        isAlmostComplete={ responseReturned }
      />
    );
  }

  // Show main verification component
  return (
    <VerifyEmailPageJSX
      code={ code }
      setCode={ setCode }
      incorrect={ incorrect }
      maskedEmail={ maskedEmail }
      handleVerify={ handleVerify }
      handleSendVerify={ handleSendVerify }
      sendNewCodeActivated={ sendNewCodeActivated }
    />
  );
};